import {LoginController} from "../modals/login";
import {ConfirmController} from "../modals/confirm";

import TPL = require("templates");

export class ForgotController {

  parent;
  modal;
  session;
  currentModal;
  rootScope;

  email;
  erroremail;

  constructor(parent, $rootScope, modal, session) {
    this.parent = parent;
    this.currentModal = this.parent.currentModal;
    this.rootScope = $rootScope;
    this.session = session;
    this.modal = modal;
    this.erroremail = "";
  }

  submit(form) {

    if (form.$valid) {
      this.session.resetPassword(this.email).then(()=> {

        if (this.currentModal) {
          this.currentModal.dismiss();
        }

        ConfirmController.openForgotPasswordDoneModal(this.modal);
      }).catch((data)=> {
        if (data.data.errors.email){
          this.erroremail="FORGOT.EMAIL_ERROR_MESSAGE";
        }
      });
    }
  }

  resetError() {
    this.erroremail=false;
  }

  openLoginDialog(which) {

    if (this.currentModal){
      this.currentModal.dismiss();
    }

    if (which == "login") {
      this.currentModal = LoginController.openLoginModal(this.modal, this, this.rootScope);
    } else {
      this.currentModal = LoginController.openSignupModal(this.modal, this, this.rootScope);
    }

  }

  static openForgotModal(modal, parent, rootScope, session) {
    return modal.open({
          controller: () => new ForgotController(parent, rootScope, modal, session),
          controllerAs: "vm",
          replace: true,
          size: "sm",
          template: TPL.modals.forgot
        });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/forgot.ts
 **/